// A'gong How We Deliver — scroll animations + counter stats
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-agong-deliver]')) return;

  var countersStarted = false;

  // ── IntersectionObserver for all fade-in elements ──
  var io = window.IntersectionObserver
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.15 })
    : null;

  // Observe header text items
  document.querySelectorAll('[data-agong-deliver-anim]').forEach(function (el) {
    if (io) io.observe(el); else el.classList.add('is-visible');
  });

  // Observe process step cards
  document.querySelectorAll('.agong-deliver__card').forEach(function (el) {
    if (io) io.observe(el); else el.classList.add('is-visible');
  });

  // ── Counter stats triggered when stats row enters view ──
  var statsEl = document.querySelector('[data-agong-deliver-stats]');
  if (!statsEl) return;

  var statsObserver = window.IntersectionObserver
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || countersStarted) return;
          countersStarted = true;
          startCounters();
          statsObserver.disconnect();
        });
      }, { threshold: 0.3 })
    : null;

  if (statsObserver) {
    statsObserver.observe(statsEl);
  } else {
    startCounters();
  }

  function startCounters() {
    document.querySelectorAll('[data-agong-counter]').forEach(function (el) {
      var type   = el.getAttribute('data-type') || 'number';
      var target = el.getAttribute('data-target') || '';
      var suffix = el.getAttribute('data-suffix') || '';

      if (type === 'text') {
        // Letter-by-letter reveal
        el.textContent = '';
        target.split('').forEach(function (char, i) {
          var span = document.createElement('span');
          span.textContent = char;
          span.style.opacity = '0';
          span.style.transition = 'opacity 0.3s ease ' + (i * 0.07) + 's';
          el.appendChild(span);
          // Trigger reflow so transition fires
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              span.style.opacity = '1';
            });
          });
        });
      } else {
        // Count-up number
        var end      = parseFloat(target) || 0;
        var duration = 2000; // ms
        var startTs  = null;

        function step(ts) {
          if (!startTs) startTs = ts;
          var progress = Math.min((ts - startTs) / duration, 1);
          // Expo ease out
          var eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
          var current = Math.round(eased * end);
          el.textContent = current.toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
    });
  }
});
